import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { Popconfirm } from 'antd';

import { getKeywordActionText, getOptimizerRightBlockWrapper } from '../optimizerRightBlockHelpers';
import { isCustomKeywordSource } from '../../../../../../../../utils/helpers/getSortedOptimizerKeywords';
import { openBasicErrorNotification } from '../../../../../../../../utils/helpers/openBasicErrorNotification';
import { getDeletePopconfirmClass } from '../../../../../../../../utils/helpers/themeHelpers';
import { useIgnoreKeyword } from '../../../../../../../../utils/hooks/useIgnoreKeyword';

import { selectDarkMode } from '../../../../../../../../userBrowserSettings/store/browserSettings.selectors';

const classes = {
    keywordIgnorePopconfirm: 'keyword-ignore-popconfirm',
};

const KeywordIgnorePopconfirm = ({ targetKeyword, children }) => {
    const darkMode = useSelector(selectDarkMode);

    const ignoreKeyword = useIgnoreKeyword();
    const [isIgnoreLoading, setIsIgnoreLoading] = useState(false);

    const handleIgnore = () => {
        if (targetKeyword?.keyword) {
            setIsIgnoreLoading(true);
            ignoreKeyword(targetKeyword, false)
                .catch(() => {
                    openBasicErrorNotification();
                })
                .finally(() => {
                    setIsIgnoreLoading(false);
                });
        }
    };

    return (
        <Popconfirm
            placement='topRight'
            title={`Are you sure you want to ${getKeywordActionText(
                isCustomKeywordSource(targetKeyword?.source),
                targetKeyword?.removed,
                true
            )} this keyword?`}
            onConfirm={handleIgnore}
            okText='Yes'
            cancelText='Cancel'
            loading={isIgnoreLoading}
            overlayClassName={`${classes.keywordIgnorePopconfirm} ${getDeletePopconfirmClass(
                darkMode
            )}`}
            getPopupContainer={getOptimizerRightBlockWrapper}
        >
            {children}
        </Popconfirm>
    );
};

export default KeywordIgnorePopconfirm;
